import { BRANCHES_MAP_SPECIFIC_ERROR_CODE_LIST } from 'core/constants/distributors.constants';
import type { IUpsertBranchClientExclusionParams } from 'core/model/interfaces/distributors/branches.interface';
import { IServiceErrorContent } from 'core/model/interfaces/service.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleSpecificErrors } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../../constants';
import type { IDistributorsState } from '../../types';

export const upsertBranchCustomersExclusion = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/upsertBranchCustomersExclusion`,
  async (params: IUpsertBranchClientExclusionParams, { rejectWithValue }) => {
    try {
      const response = await apiService.branches.upsertBranchCustomersExclusion(params);

      notificationService.global.success('Se ha cargado la exclusión de clientes correctamente.');

      return response;
    } catch (error) {
      const handledError = handleSpecificErrors(error, 'Error al cargar el archivo. Por favor Inténtalo de nuevo.', [
        ...BRANCHES_MAP_SPECIFIC_ERROR_CODE_LIST.keys(),
      ]);

      if (handledError) {
        return rejectWithValue(handledError);
      }

      throw error;
    }
  },
);

export const upsertBranchCustomerExclusionReducer: TSliceExtraReducer<IDistributorsState> = builder =>
  builder
    .addCase(upsertBranchCustomersExclusion.pending, state => {
      state.branchesList.form.loading = true;
      state.branchesList.form.success = false;
      state.branchesList.form.errors = {};
    })
    .addCase(upsertBranchCustomersExclusion.rejected, (state, action) => {
      state.branchesList.form.loading = false;
      state.branchesList.form.success = false;

      const errorContent = action.payload as IServiceErrorContent<string>;

      BRANCHES_MAP_SPECIFIC_ERROR_CODE_LIST.forEach((errorKey, errorCode) => {
        if (errorContent?.code === errorCode) {
          state.branchesList.form.errors[errorKey as string] = errorContent.details.join('\n\n');
        }
      });
    })
    .addCase(upsertBranchCustomersExclusion.fulfilled, state => {
      state.branchesList.form.loading = false;
      state.branchesList.form.success = true;
      state.branchesList.form.errors = {};
    });
